<template lang="html">
  <section>
    <v-row dense class="justify-center">
      <v-col id="testarea" data-cy="testBereich" cols="11">
        <h2>Finance Bereich</h2>
      </v-col>
    </v-row>

    <v-row dense class="mt-5 justify-center">
      <v-col cols="11">
        <v-card>
          <v-card-title color="orange accent-1">
            Verrechenbarkeit
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="2">
                <v-text-field id="fromDateVerrechenbar" class="ma-0 pa-0" placeholder="DD.MM.YYYY" ref="fromDateVerrechenbar"
                  label="Von"
                  :value="fromDateVerrechenbar"
                  readonly
                  dense
                  @click="menuFromVerrechenbar = true">

                  <template v-slot:append>
                    <v-menu ref="menuFromVerrechenbar" v-model="menuFromVerrechenbar" :close-on-content-click="false"
                      transition="slide-y-transition"
                      offset-y
                      left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" class="mt-1 grow-icon" size="20">mdi-calendar</v-icon>
                      </template>
                      <v-date-picker color="#c00000" no-title scrollable v-model="fromDateVerrechenbar" type="month"
                        @input="menuFromVerrechenbar = false" />
                    </v-menu>
                    </template>
                </v-text-field>
              </v-col>

              <v-col cols="2">
                <v-text-field id="toDateVerrechenbar" class="ma-0 pa-0" placeholder="DD.MM.YYYY" ref="toDateVerrechenbar"
                  label="Bis"
                  :value="toDateVerrechenbar"
                  readonly
                  dense
                  @click="menuToVerrechenbar = true">

                  <template v-slot:append>
                    <v-menu ref="menuToVerrechenbar" v-model="menuToVerrechenbar" :close-on-content-click="false"
                      transition="slide-y-transition"
                      offset-y
                      left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" class="mt-1 grow-icon" size="20">mdi-calendar</v-icon>
                      </template>
                      <v-date-picker color="#c00000" no-title scrollable v-model="toDateVerrechenbar" type="month"
                        @input="menuToVerrechenbar = false" />
                    </v-menu>
                    </template>
                </v-text-field>
              </v-col>

              <v-col cols="2">
                <v-btn id="generateVerrechenbarReportButton" type="button" :loading="loading" @click.native="generateVerrechenbarReport()" color="#c00000" class="white--text">Verrechenbarkeit Report erstellen</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
        
    <v-snackbar id="errorMessage" v-if="errorHandling.showError" v-model="errorHandling.showError" bottom
      color="red accent-2">
      <v-progress-circular indeterminate color="white"> </v-progress-circular>
      {{ errorHandling.errorMessage }}
    </v-snackbar>
  </section>
</template>

<script lang="js">
  import dayjs from '@util/dayjs';
  import * as faClient from '@client/client.fa';

  const lastMonth = dayjs().subtract(1, 'month').format('YYYY-MM');
  
  export default {
    name: 'Finance',
    data() {
      return {
        loading: false,
        fromDateVerrechenbar: lastMonth,
        menuFromVerrechenbar: false,
        toDateVerrechenbar: lastMonth,
        menuToVerrechenbar: false,
        errorHandling: {
          showError: false,
          errorMessage: ''
        },
      }
    },

    computed: {
      fromVerrechenbar: function() {
        return dayjs(this.fromDateVerrechenbar).startOf('month').format('YYYY-MM-DD');
      },
      toVerrechenbar: function() {
        return dayjs(this.toDateVerrechenbar).endOf('month').format('YYYY-MM-DD');
      }
    },

    methods: {
      async generateVerrechenbarReport() {
        try {
          this.loading = true;
          const csvString = await faClient.generateVerrechenbarReport(this.fromVerrechenbar, this.toVerrechenbar);
          this._downloadCSV(csvString, 'Verrechenbarkeit_Report', this.fromVerrechenbar, this.toVerrechenbar);
        } catch (error) {
          this.errorHandling.showError = true;
          this.errorHandling.errorMessage = `Report-Generierung ist fehlgeschlagen.\n\n Error: ${error.message}`;
        } finally {
          this.loading = false;
        }
      },      

      _downloadCSV(csvString, filename, from, to) {
        const mocoEnv = this.$store.getters.userAuthenticationData.mocoEnv;
        const fromMonth = dayjs(from).format('YYYY_MM');
        const toMonth = dayjs(to).format('YYYY_MM');
        
        let filenameAddOns;
        if (fromMonth == toMonth) {
          filenameAddOns = `${mocoEnv}_${fromMonth}`;
        } else {
          filenameAddOns = `${mocoEnv}_${fromMonth}-${toMonth}`;
        }
        
        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${filename}_${filenameAddOns}.csv`); 

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    }
  }
</script>
  
<style lang="scss">
#testarea .chip span {
  cursor: pointer;
}
</style>